import { Star, ExternalLink } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { INFO } from "@/data/site";
import { useLang } from "@/i18n";

const GoogleReviews = () => {
  const { t } = useLang();
  const googleUrl = INFO.googleBusiness || "";
  const hasProfile = !!googleUrl;
  return (
    <Reveal delay={0.1}>
      <div data-testid="google-reviews" className="flex flex-col h-full">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-10 h-px bg-primary" />
          <span className="text-xs uppercase tracking-[0.25em] text-primary">{t("social.eyebrow")}</span>
        </div>
        <h3 className="font-serif font-light text-3xl md:text-4xl leading-tight">
          {t("social.title")}
        </h3>

        <div className="mt-8 flex-1 bg-primary text-primary-foreground p-8 md:p-10 flex flex-col justify-between min-h-[440px]">
          <div>
            <div className="flex items-center gap-2 mb-6" data-testid="google-stars">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={20} strokeWidth={1.25} className="fill-current" />
              ))}
              <span className="ml-2 text-sm opacity-80 tracking-wide">5,0</span>
            </div>
            <p className="font-serif text-2xl md:text-3xl leading-snug font-light">
              „{t("hero.tagline")}"
            </p>
          </div>
          {hasProfile ? (
            <a
              href={googleUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="google-review-cta"
              className="mt-8 inline-flex items-center justify-between gap-4 bg-primary-foreground text-primary px-7 py-4 text-sm tracking-wide group"
            >
              <span>{t("reviews.on_google")}</span>
              <ExternalLink size={16} strokeWidth={1.5} className="transition-transform group-hover:translate-x-1" />
            </a>
          ) : (
            <span className="mt-8 inline-block text-xs uppercase tracking-[0.25em] opacity-60" data-testid="google-review-placeholder">
              {t("social.placeholder")}
            </span>
          )}
        </div>
      </div>
    </Reveal>
  );
};

export const SocialProof = () => {
  return (
    <section id="sozial" data-testid="social-proof" className="bg-secondary border-y border-border">
      <div className="mx-auto max-w-[900px] px-5 md:px-10 py-24 md:py-32">
        <GoogleReviews />
      </div>
    </section>
  );
};
